import { mxGraphModel } from 'mxgraph-js';

class HCLMxGraphModel extends mxGraphModel {

}

export default HCLMxGraphModel;
